export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-links",
  },
  {
    title: "About",
    url: "/about",
    cName: "nav-links",
  },
  {
    title: "Press",
    url: "/press",
    cName: "nav-links",
  },
  {
    title: "Blog",
    url: "/blog",
    cName: "nav-links",
  },
  {
    title: "Fit Tips",
    url: "/fit-tips",
    cName: "nav-links",
  },
  {
    title: "Contact",
    url: "/contact",
    cName: "nav-links",
  },
  {
    title: "Log Out",
    url: "/",
    cName: "nav-links-mobile",
  },
];
